import React from "react";

import { Link } from "gatsby";

import { SessionType } from "@/autoGeneratedGlobalTypes";
import { Button, ButtonColorEnum, ButtonIconPositionEnum } from "@/components/common/button";
import { Icon, IconSizeEnum, IconTypeEnum } from "@/components/common/icon";
import { UserAvatar } from "@/components/common/userAvatar";
import { UserAvatarTypeEnum } from "@/components/common/userAvatar/types";
import UserInfo from "@/components/common/userInfo";
import { useEndSession } from "@/hooks/useEndSession";
import { useSessionNavigation } from "@/hooks/useSessionNavigation";

import type { WaitingAlertProps } from "./types";

import "../../styles.scss";
import "./styles.scss";

const WaitingAlert = (props: WaitingAlertProps) => {
  const { client, expert, isExpert, sessionId, sessionType } = props;
  const receiver = isExpert ? client : expert;

  // Hooks для навигации и завершения сессии
  const { navigateToSession } = useSessionNavigation();
  const { handleEndSession } = useEndSession({ sessionId, receiver, isExpert, sessionType });

  const handleNavigateClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigateToSession(sessionType || SessionType.VIDEO_CALL, sessionId);
  };

  const sessionUrl = sessionType === SessionType.CHAT
    ? `/textChat?sessionId=${sessionId}`
    : `/chat?sessionId=${sessionId}`;

  return (
    <>
      <div className="modal__top" />
      <div className="modal__content alert__modal alert-waiting">
        {receiver && (
          <UserInfo
            avatar={(
              <UserAvatar
                mobileImage={receiver.mobileImage}
                desktopImage={receiver.desktopImage}
                userId={receiver.id}
                name={receiver.name}
                type={UserAvatarTypeEnum.Call}
              />
            )}
          >
            <div className="alert__modal-icon alert-waiting__modal-icon">
              {sessionType === SessionType.CHAT ? (
                <Icon
                  type={IconTypeEnum.ChatIncoming}
                  size={IconSizeEnum.Size48}
                  viewBox={46}
                />
              ) : (
                <Icon
                  type={IconTypeEnum.CallIncoming}
                  size={IconSizeEnum.Size48}
                />
              )}
            </div>
          </UserInfo>
        )}
        <h2 className="h2">
          {isExpert ? "Клиент " : "Эксперт "}
          {" "}
          ожидает вас
        </h2>
        <div className="alert__modal-buttons">
          <div className="alert__modal-button">
            <Link onClick={handleNavigateClick} to={sessionUrl}>
              <Button
                text="Начать консультацию"
                icon={IconTypeEnum.Right}
                iconPosition={ButtonIconPositionEnum.Right}
              />
            </Link>
          </div>
          {!isExpert && (
            <div className="alert__modal-button">
              <Button
                text="Завершить"
                color={ButtonColorEnum.White}
                onClick={handleEndSession}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default WaitingAlert;
